import React, {useEffect, useState} from 'react';
import {CheckboxButton, DatePickerCustom, InputFormat, InputLista, Accordion, FormError, FormLabel} from '../../../../components/common';
import DataTaggerFormRedux from '../../../../components/controls/DataTaggerFormRedux';
import DomiciliosGrid from '../../../../components/controls/DomiciliosGrid';
import VinculosInmuebleGrid from '../../../../components/controls/VinculosInmuebleGrid';
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, PATTERNS, ShowToastMessage } from '@laramie/ui';
import {MakeListDomicilios} from '../../utils';
import {TabsForm} from './components';
import InputSecret from '../../../../components/common/InputSecret';
import {usePermissions} from '../../../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../../../consts/permissions';

const SectionForm = ({
                         SetTabActive,
                         pendingChange,
                         setPendingChange,
                         state,
                         inmueble_formValues,
                         inmueble_formSet,
                         inmueble_formHandleProxy,
                         cuenta_formValues,
                         cuenta_formHandleProxy,
                         UpdateEntity,
                         handleClickBaja,
                         refetchInmueble,
                         errorOf,
                         estadoOpen,
                         setEstadoOpen
                     }) => {

    const [domicilios, setDomicilios] = useState([]);

    const {hasPermission} = usePermissions();
    const canEditPersonasVinculadas = hasPermission(PERMISSIONS.PERSONAS_VINCULADAS_EDIT);

    useEffect(() => {
        if (state.entity.ladosTerreno.length > 0 || state.entity.zonasEntrega.length > 0 || state.entity.vinculosInmueble.length > 0) {
            MakeListDomicilios(state)
                .then(response => {
                    setDomicilios(response);
                })
                .catch(error => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setDomicilios([]);
                });
        } else {
            if (domicilios.length > 0) setDomicilios([]);
        }
    }, [state.entity.ladosTerreno, state.entity.zonasEntrega, state.entity.vinculosInmueble])

    return (
        <>
            <section className='section-accordion'>

                <div className="m-top-20 m-bottom-20">
                    <Accordion title="Cuenta" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-3 col-lg-2">
                                <label htmlFor="cuenta_numeroCuenta" className="form-label">Número de cuenta</label>
                                <InputFormat
                                    name="cuenta_numeroCuenta"
                                    placeholder="[autonumérico]"
                                    className="form-control"
                                    mask={MASK_FORMAT.CUENTA}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroCuenta}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-6 col-md-4 col-lg-2">
                                <label htmlFor="cuenta_numeroWeb" className="form-label">Clave web</label>
                                <InputSecret
                                    name="cuenta_numeroWeb"
                                    mask={MASK_FORMAT.CLAVE_WEB}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroWeb}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                            </div>
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado de
                                            cuenta</label>
                                        <InputLista
                                            name="cuenta_idEstadoCuenta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.idEstadoCuenta}
                                            disabled={true}
                                            lista="EstadoCuenta"
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaAlta" className="form-label">Fecha alta</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaAlta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaAlta}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaBaja" className="form-label">Fecha baja</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaBaja"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaBaja}
                                            disabled={true}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </Accordion>

                    {(state.mode !== OPERATION_MODE.NEW) && (
                        <>
                            <div className="m-top-20">
                                <Accordion title="Personas vinculadas">
                                    <VinculosInmuebleGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditPersonasVinculadas}
                                        data={{
                                            idInmueble: state.id,
                                            list: state.entity.vinculosInmueble
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Domicilios">
                                    <DomiciliosGrid
                                        data={{
                                            list: domicilios
                                        }}
                                    />
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Información catastral">
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="catastralPartido" className="form-label">Partido</label>
                                            <input
                                                name="catastralPartido"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralPartido}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralPartido: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralCir" className="form-label">Cir.</label>
                                            <input
                                                name="inmueble_catastralCir"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralCir}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralCir: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralSec" className="form-label">Sec.</label>
                                            <input
                                                name="inmueble_catastralSec"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralSec}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralSec: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralCodigo"
                                                   className="form-label">Código</label>
                                            <input
                                                name="inmueble_catastralCodigo"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralCodigo}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralCodigo: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralChacra"
                                                   className="form-label">Chacra</label>
                                            <input
                                                name="inmueble_catastralChacra"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralChacra}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralChacra: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralLchacra"
                                                   className="form-label">L.Chacra</label>
                                            <input
                                                name="inmueble_catastralLchacra"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralLchacra}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralLchacra: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralQuinta"
                                                   className="form-label">Quinta</label>
                                            <input
                                                name="inmueble_catastralQuinta"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralQuinta}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralQuinta: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralLquinta"
                                                   className="form-label">L.Quinta</label>
                                            <input
                                                name="inmueble_catastralLquinta"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralLquinta}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralLquinta: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralFrac" className="form-label">Frac.</label>
                                            <input
                                                name="inmueble_catastralFrac"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralFrac}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralFrac: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralLfrac"
                                                   className="form-label">L.Frac.</label>
                                            <input
                                                name="inmueble_catastralLfrac"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralLfrac}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralLfrac: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralManz" className="form-label">Manz.</label>
                                            <input
                                                name="inmueble_catastralManz"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralManz}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralManz: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralLmanz"
                                                   className="form-label">L.Manz.</label>
                                            <input
                                                name="inmueble_catastralLmanz"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralLmanz}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralLmanz: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralParc" className="form-label">Parc.</label>
                                            <input
                                                name="inmueble_catastralParc"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralParc}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralParc: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralLparc"
                                                   className="form-label">L.Parc.</label>
                                            <input
                                                name="inmueble_catastralLparc"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralLparc}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralLparc: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralSubparc"
                                                   className="form-label">SubParc.</label>
                                            <input
                                                name="inmueble_catastralSubparc"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralSubparc}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralSubparc: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralUfunc"
                                                   className="form-label">U.Func.</label>
                                            <input
                                                name="inmueble_catastralUfunc"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralUfunc}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralUfunc: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-1">
                                            <label htmlFor="inmueble_catastralUcomp"
                                                   className="form-label">U.Comp.</label>
                                            <input
                                                name="inmueble_catastralUcomp"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralUcomp}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralUcomp: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="inmueble_catastralRtasPrv" className="form-label">Rentas.
                                                Prov.</label>
                                            <input
                                                name="inmueble_catastralRtasPrv"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.catastralRtasPrv}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            catastralRtasPrv: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="inmueble_tributoManz" className="form-label">Manz.
                                                (Escritura)</label>
                                            <input
                                                name="inmueble_tributoManz"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.tributoManz}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            tributoManz: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
                                            <label htmlFor="inmueble_tributoLote" className="form-label">Lote (Escritura)</label>
                                            <input
                                                name="inmueble_tributoLote"
                                                type="text"
                                                placeholder=""
                                                className="form-control"
                                                value={inmueble_formValues.tributoLote}
                                                onChange={({target}) => {
                                                    if (target.validity.valid) {
                                                        inmueble_formSet({
                                                            ...inmueble_formValues,
                                                            tributoLote: target.value
                                                        });
                                                        setPendingChange(true);
                                                    }
                                                }}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-3 col-xl-2 m-top-20">
                                            <CheckboxButton
                                                name="inmueble_tributoEsquina"
                                                label="Es esquina"
                                                checked={inmueble_formValues.tributoEsquina}
                                                onChange={inmueble_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                            />
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Estado" open={estadoOpen} onToggle={setEstadoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <FormLabel htmlFor="inmueble_idEstadoCarga" required>Estado de carga</FormLabel>
                                            <InputLista
                                                name="inmueble_idEstadoCarga"
                                                placeholder=""
                                                className={`form-control ${errorOf('idEstadoCarga') ? 'is-invalid' : ''}`}
                                                value={inmueble_formValues.idEstadoCarga}
                                                onChange={inmueble_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || state.entity.inmueble.idEstadoCarga !== 20}
                                                lista="EstadoCarga"
                                            />
                                            <FormError message={errorOf('idEstadoCarga')} />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="inmueble_fechaCargaInicio" className="form-label">Fecha
                                                inicio carga</label>
                                            <DatePickerCustom
                                                name="inmueble_fechaCargaInicio"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.inmueble.fechaCargaInicio}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="inmueble_fechaCargaFin" className="form-label">Fecha fin
                                                carga</label>
                                            <DatePickerCustom
                                                name="inmueble_fechaCargaFin"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.inmueble.fechaCargaFin}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                                                <button className="btn action-button float-end m-top-30"
                                                        data-dismiss="modal"
                                                        onClick={(event) => handleClickBaja()}>Baja</button>
                                            }
                                        </div>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="m-top-20">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                        title="Información adicional de inmueble"
                                        processKey={state.processKey}
                                        entidad="Inmueble"
                                        idEntidad={state.id}
                                        disabled={(state.mode === OPERATION_MODE.VIEW)}
                                        onChange={(row) => setPendingChange(true)}
                                    />
                                </Accordion>
                            </div>

                            <TabsForm
                                state={state}
                                SetTabActive={SetTabActive}
                                UpdateEntity={UpdateEntity}
                                pendingChange={pendingChange}
                                refetchInmueble={refetchInmueble}
                            />

                        </>
                    )}

                </div>

            </section>

        </>
    )
}

export default SectionForm
